<template>
    <div class="flex items-center justify-center w-full h-6 px-4 text-xs bg-vida-beige-2">
        Copyright &copy;2021 - &nbsp;<a href="http://vidadoors.be" target="_blank">VIDA DOORS</a>
    </div>
</template>

<script>
    export default {

    }
</script>

<style>

</style>